import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
// [[Modulos da Aplicação]]
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
import { PaginationModule } from '~components/pagination/pagination.module';
// import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { TranslatePipeModule } from '~pipes/translate';
import { UseHtmlPipeModule } from '~pipes/html';
import { UseJsonLdPipeModule } from '~pipes/json-ld';
// import { CarouselModule } from "ngx-bootstrap/carousel";
import { IncludeProductContainerModule } from '~components/include/product/container/module';
import { IncludeProductBuyModule } from '~components/include/product/buy/module';
import { IncludeProductBuyInlineModule } from '~components/include/product/buyInline/module';
// []
// [[PrimeNg]]
import { DialogModule } from 'primeng/dialog';
import { ImageModule } from 'primeng/image';
import { ToastModule } from 'primeng/toast';
import { InputMaskModule } from 'primeng/inputmask';
import { GalleriaModule } from 'primeng/galleria';
// []
// [[Providers/Services da Aplicação]]
import { ErrorService } from '~services/error.service';
import { ClientMarketplaceCartService } from '~services/panel/client/marketplace/cart/cart.service';
import { CustomerAddressService } from '~services/panel/client/marketplace/customer/localization/address.service';
import { CustomerWishlistService } from '~services/panel/client/marketplace/customer/wishlist/wishlist.service';
import { ClientMarketplaceCoreProductImageService } from '~services/collective/client/marketplace/core/product/image/image.service';
import { ClientMarketplaceCoreProductRelUsageService } from '~services/collective/client/marketplace/core/product/relusage/relusage.service';
import { ClientMarketplaceCartProductService } from '~services/collective/client/marketplace/cart/product/product.service';
import { ClientMarketplaceCoreConfigurationPaymentService } from '~services/collective/client/marketplace/core/configuration/payment/payment.service';
import { CustomerFinancialPaymentMethodCreditcardService } from '~services/panel/client/marketplace/customer/financial/payment/method/creditcard.service';
import { CollectiveMarketplaceCoreSubscriptionService } from '~services/collective/client/marketplace/core/subscription/subscription.service';
import { CustomerNoticeService } from '~services/panel/client/marketplace/customer/notice/notice.service';
// []
// [[Rotas da Aplicação]]
import { ModuleRoutes } from './routing';
// []
// [[Componentes da Aplicação]]
import { ProductViewComponent, CartSwapComponent, CartViewComponent, CheckoutViewComponent } from './index';
// []
@NgModule({
  imports: [
    //
    LoadingBarHttpClientModule,
    CommonModule,
    RouterModule.forChild(ModuleRoutes),
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    PaginationModule,
    TranslatePipeModule,
    UseHtmlPipeModule,
    UseJsonLdPipeModule,
    //
    IncludeProductContainerModule,
    IncludeProductBuyModule,
    IncludeProductBuyInlineModule,
    //PrimeNg
    ImageModule,
    ToastModule,
    DialogModule,
    InputMaskModule,
    GalleriaModule,
  ],
  declarations: [
    //

    ProductViewComponent,
    CartSwapComponent,
    CartViewComponent,
    CheckoutViewComponent,
  ],
  providers: [
    ErrorService,
    ClientMarketplaceCartService,
    CustomerAddressService,
    CustomerWishlistService,
    ClientMarketplaceCoreProductImageService,
    ClientMarketplaceCoreProductRelUsageService,
    ClientMarketplaceCartProductService,
    ClientMarketplaceCoreConfigurationPaymentService,
    CustomerFinancialPaymentMethodCreditcardService,
    CollectiveMarketplaceCoreSubscriptionService,
    CustomerNoticeService,
  ],
})
export class PageModule {}
